import React, { FC } from 'react';

import { useDesktop, Stack, Box, useMediaSwitch, useMobile, Typography } from 'Modules/ui3';
import { Public24 } from 'Modules/ui3/icons/Public24';

import { OPERATOR_EMAIL } from '../../constants';


export const Special: FC = () => {
    const isDesktop = useDesktop();
    const isMobile = useMobile();
    return (
        <Box px={isDesktop ? 4 : 0} mt={useMediaSwitch(0, -10, -8)}>
            <Stack
                px={useMediaSwitch(12, 6, 4)}
                py={useMediaSwitch(37, 6, 4)}
                justifyContent='center'
                alignItems='center'
                bgcolor='#141414'
                height={isMobile ? '610px' : '800px'}
                {...isDesktop && {
                    borderRadius: 12,
                }}
            >
                <Stack
                    maxWidth='1200px'
                    alignItems='center'
                    spacing={isMobile ? 6 : 8}
                >
                    <Stack
                        px={isMobile ? 4 : 6}
                        py={isMobile ? 2 : 3}
                        bgcolor='rgba(255, 255, 255, 0.08)'
                        borderRadius={5}
                        direction='row'
                        spacing={isMobile ? 2 : 3}
                    >
                        <Public24
                            sx={{
                                fontSize: isMobile ? '18px' : '24px',
                                '& path': {
                                    fill: '#DBDBDB',
                                },
                            }}
                        />
                        <Typography
                            fontFamily='Hauora'
                            fontSize={isMobile ? '12px' : '16px'}
                            fontWeight={600}
                            lineHeight={1.5}
                            color='#DBDBDB'
                        >
                            Для компаний
                        </Typography>
                    </Stack>
                    <Typography
                        fontFamily='Hauora'
                        fontSize={useMediaSwitch('72px', '48px', '28px')}
                        lineHeight={1.3}
                        fontWeight={700}
                        color='#6E6D6A'
                        textAlign='center'
                        sx={{
                            '&>span': {
                                color: '#F4F4F4',
                            },
                        }}
                    >
                        Специальные условия для&nbsp;
                        <span>
                            корпоративных
                        </span>
                        {' '}инвесторов
                    </Typography>
                    <Typography
                        fontFamily='Hauora'
                        fontSize={isMobile ? '14px' : '20px'}
                        fontWeight={500}
                        lineHeight={isMobile ? '20px' : '32px'}
                        color='#6E6D6A'
                        sx={{
                            '&>span': {
                                color: '#F4F4F4',
                            },
                        }}
                    >
                        Принимаем заявки на <span>{OPERATOR_EMAIL}</span>
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
};
